<!-- 申请退款 -->
<template>
	<div class="wrap">

		<div class="middle-container">
			<p class="middle-container-top">申请退款</p>

			<div class="item-module">
				<div class="item-big">
					<div class="msg-module">
						<img :src="BASE_URL + goods.sku_image" class="produt-img">
						<div class="msg-module-sidebar">
							<p class="produt-title">{{ goods.sku_name }}</p>
							<p class="produt-tag">支持7天无理由退换货</p>
						</div>
					</div>
				</div>
				<div class="produt-msg-box">
					<p class="produt-msg" v-for="(item2, index2) in goods.sku_spec_format" :key="index2">
            {{ item2.spec_name }}：{{ item2.spec_value_name }}
          </p>
				</div>
				<div class="price-box">
					<span class="produt-price">¥ {{ goods.price }}</span>
					<span class="produt-price-del">¥ {{ goods.cost_price }}</span>
				</div>
				<div class="calc-box">
					<span class="calc-num">{{ goods.num }}</span>
				</div>
				<div class="total-price-box">
					<span class="font-1">¥ {{ goods.goods_money }}</span>
					<span class="font-2">（运费:0.00）</span>
				</div>
			</div>


			<div class="price-module">
				<div class="price-module-between">
					<span class="font-7">退款金额</span>
					<span class="font-8">¥{{ goods.goods_money }}</span>
				</div>
			</div>

			<div class="order-msg-module" style="padding-bottom: 4px;">
				<p class="order-msg-label">退款原因 <span>（请选择）</span> </p>
				<ul class="reason-for-refund-list">
					<li v-for="(item, index) in reasonList" :key="index" @click="params.refund_reason = item">
						<img v-if="item === params.refund_reason" src="../assets/circle-active.png">
            <img v-else src="../assets/circle.png">
            {{ item }}
					</li>
				</ul>
			</div>

			<div class="order-msg-module">
				<p class="order-msg-label">退款说明<span>（选填）</span> </p>
				<textarea class="refund-instructions" v-model="params.refund_remark" rows="" placeholder="请输入退款说明" cols=""></textarea>
			</div>

			<div class="order-msg-module">
				<p class="order-msg-label">上传图片<span>（选填）</span> </p>
				<div class="upload-wrap">
					<div class="upload-module">
						<div class="upload-box" v-for="(item, index) in images" :key="index">
							<img :src="BASE_URL +  item" class="upload-img">
						</div>
						<div class="upload-box">
							<img src="../assets/upload-4.png" class="upload-img">
              <input type="file" @change="uploadImage($event, 'refund_image')" />
						</div>
					</div>
				</div>
			</div>

			<div class="btn-box-end">
				<button type="button" @click="$router.back()">返回</button>
				<button type="button" @click="submit()">申请退款</button>
			</div>

		</div>


	</div>
</template>

<script>
import {Message, MessageBox} from "element-ui";
  import {BASE_URL} from "@/common/config";
import {OrderrefundService, uploadFile} from "@/common/service";
  import {validatorFun} from "@/common/util";

  export default {
		data() {
			return {
        BASE_URL,
        goods: {},
        order: {},

        reasonList: [
          '产品质量差',
          '卖家发错货',
          '拍多/拍错',
          '尺寸与描述不符',
          '未按约定时间发货',
          '产品变质',
        ],

        images: [],
        params: {
          order_goods_id: '', // 订单商品id
          refund_reason: '', // 退款原因
          refund_remark: '', // 退款说明
          refund_image: '', // 图片
        },
			};
		},
		mounted() {
      this.init();
    },
		methods: {
      submit() {
        this.params.refund_image = this.images.join(',');
        const validatorNullList = [
          ['refund_reason', ['notNull', '请选择退款原因']],
          ['refund_remark', ['notNull', '请输入退款说明']],
          ['refund_image', ['notNull', '请上传图片']],
        ];
        const validatorNullResult = validatorFun(this.params, validatorNullList);
        if (validatorNullResult.length > 0) {
          return Message.warning(validatorNullResult[0].errMsg);
        }
        return console.log(JSON.stringify(this.params, null, 2));
        MessageBox({
          type: 'warning',
          title: '提示',
          message: '确定申请退款？',
          showCancelButton: true,
        }).then(() => {
          OrderrefundService.refund(this.params).then(({message}) => {
            Message.success(message);
            setTimeout(() => this.$router.back(), 1000);
          });
        });

      },
      uploadImage(e, key) {
        const file = e.target.files[0];
        if (!!file) {
          uploadFile(file).then(({data}) => {
            this.images.push(data.pic_path);
          });
        }
      },
      init() {
        const data = localStorage.getItem('page_apply-for-refund_data');
        localStorage.removeItem('page_apply-for-refund_data');
        try {
          const {
            goods,
            order,
          } = JSON.parse(data);
          this.goods = goods;
          this.order = order;
          this.params.order_goods_id = goods.order_goods_id;
        } catch (e) {
          MessageBox({
            type: 'warning',
            title: '提示',
            message: '获取数据错误！',
            confirmButtonText: '返回'
          }).then(() => {
            this.$router.back();
          });
        }
      },
    },
	};
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.middle-container {
		width: 100%;
		min-height: calc(100vh - 314px);
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.footer {
		width: 100%;
		height: 271px;
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.footer-middle {
		width: calc(1200px - 292px);
		display: flex;
		flex-direction: column;
	}

	.footer-tag-list {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.footer-tag-list>li {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.footer-tag-icon {
		width: 56px;
		margin-bottom: 14px;
	}

	.footer-bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 8px;
		box-sizing: border-box;
		margin-top: 37px;
	}

	.footer-bottom-left {
		flex: 1;
		display: flex;
		align-items: center;
		margin-right: 135px;
	}

	.footer-bottom-left-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.footer-bottom-left-list>li {
		width: 33.3333%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #666666;
		font-size: 16px;
		font-weight: bold;
		margin-top: 15px;
	}

	.footer-bottom-left-list>li:first-child,
	.footer-bottom-left-list>li:nth-child(2),
	.footer-bottom-left-list>li:nth-child(3) {
		margin-top: 0;
	}

	.footer-bottom-right {
		display: flex;
		align-items: center;
	}

	.footer-bottom-right-img {
		width: 48px;
		margin-right: 7px;
	}

	.footer-bottom-right-row {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.footer-font1 {
		color: #C69236;
		font-size: 28px;
		font-weight: bold;
	}

	.footer-font2 {
		color: #333333;
		font-size: 16px;
		font-weight: bold;
	}

	.middle-container {
		width: 1200px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.middle-container-top {
		width: 100%;
		height: 41px;
		line-height: 41px;
		display: flex;
		align-items: center;
		background: linear-gradient(180deg, #F3DC99, #F0AE46);
		padding: 0 30px;
		box-sizing: border-box;
		font-size: 18px;
		color: #FFFFFF;
		font-weight: bold;
		margin-bottom: 10px;
		margin-top: 26px;
		border-radius: 12px 12px 0 0;
	}

	.item-module {
		width: 100%;
		display: flex;
		align-items: center;
		border-radius: 4px;
		padding: 30px 42px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		margin-bottom: 10px;
	}

	.item-big {
		width: calc(100% - 738px);
		display: flex;
		align-items: center;
	}

	.circle-box {
		width: 83px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.circle-img {
		width: 16px;
	}

	.msg-module {
		display: flex;
		align-items: center;
	}

	.produt-img {
		width: 120px;
		height: 120px;
		display: flex;
		align-items: center;
		margin-right: 15px;
	}

	.msg-module-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.produt-title {
		width: 145px;
		color: #333333;
		font-size: 12px;
		font-weight: bold;
		margin-bottom: 9px;
	}

	.produt-msg {
		color: #333333;
		font-size: 16px;
	}

	.produt-tag {
		color: #FF6619;
		font-size: 12px;
		margin-top: 9px;
	}

	.produt-msg-box {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.price-box {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.produt-price {
		color: #333333;
		font-size: 18px;
		font-weight: bold;
	}

	.produt-price-del {
		color: #999999;
		font-size: 12px;
		font-weight: bold;
		text-decoration: line-through;
		margin-top: 5px;
	}

	.calc-box {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.commodity-operation {
		width: 123px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.operation {
		color: #666666;
		font-size: 12px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.operation:last-child {
		margin-bottom: 0;
	}

	.order-status {
		width: 123px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.status {
		color: #666666;
		font-size: 12px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.status:last-child {
		margin-bottom: 0;
	}

	.status.orange {
		color: #FF6619;
	}



	.total-price-box {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.font-1 {
		color: #FF6619;
		font-size: 18px;
		font-weight: bold;
	}

	.font-2 {
		color: #333333;
		font-size: 12px;
		margin-top: 1px;
	}

	.calc-num {
		color: #333333;
		font-size: 18px;
		font-weight: bold;
	}

	.price-module {
		width: 100%;
		height: 60px;
		line-height: 60px;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 0 42px;
		box-sizing: border-box;
	}

	.price-module-label {
		width: 100%;
		color: #333333;
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 15px;
	}

	.price-module-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}

	.price-module-between:last-child {
		margin-bottom: 0;
	}

	.font-6 {
		color: #333333;
		font-size: 18px;
	}

	.row-1 {
		display: flex;
		align-items: center;
		color: #AB6200;
		font-size: 18px;
	}

	.row-1>img {
		width: 24px;
		margin-right: 11px;
	}

	.row-2 {
		color: #333333;
		font-size: 18px;
	}

	.row-2>span {
		color: #F37C3D;
		font-weight: bold;
	}

	.font-7 {
		color: #333333;
		font-size: 18px;
		font-weight: bold;
	}

	.font-8 {
		color: #FF6619;
		font-size: 18px;
		font-weight: bold;
	}

	.btn-box-end {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 17px 0 27px;
	}

	.btn-box-end>button {
		width: 131px;
		height: 52px;
		line-height: 52px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 8px;
		background-color: #FF6619;
		color: #FFFFFF;
		font-size: 20px;
		margin-right: 59px;
	}

	.btn-box-end>button:last-child {
		margin-right: 0;
	}

	.order-msg-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		padding: 13px 42px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.order-msg-label {
		width: 100%;
		color: #333333;
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 15px;
	}

	.order-msg-label>span {
		color: #999999;
		font-weight: normal;
	}

	.order-number {
		width: 100%;
		color: #333333;
		font-size: 16px;
		margin-bottom: 13px;
	}

	.reason-for-refund-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.reason-for-refund-list>li {
		width: 20%;
		display: flex;
		align-items: center;
		color: #333333;
		font-size: 16px;
		margin-bottom: 8px;
	}

	.reason-for-refund-list>li>img {
		width: 16px;
		margin-right: 6px;
	}

	.refund-instructions {
		width: 100%;
		height: 120px;
		background-color: #EEEEEE;
		border-radius: 8px;
		padding: 13px 16px;
		box-sizing: border-box;
		font-size: 16px;
		color: #333333;
	}

	.refund-instructions::placeholder {
		color: #999999;
	}

	.upload-wrap {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.upload-module {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.upload-box {
		width: 120px;
		height: 120px;
		margin-right: 10px;
    position: relative;
  }
  .upload-box input[type="file"] {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

	.upload-img {
		width: 100%;
		height: 100%;
		border-radius: 8px;
	}
</style>
